export const booleanData = [
    {key: 'yes', text: 'Yes', value: "yes"},
    {key: 'no', text: 'No', value: "no"},
];

export const roundTypeData = [
    {key: 'online', text: 'Online', value: "online"},
    {key: 'offline', text: 'Offline', value: "offline"},
];